var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAgencymoduleActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-agencymodule-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#082850",
    d: "M27.947 3.826l-11.6-3.501c-0.227-0.069-0.467-0.069-0.694 0l-11.605 3.501c-0.506 0.152-0.853 0.618-0.853 1.147v16.864c0 0.378 0.178 0.734 0.48 0.962l11.602 8.691c0.213 0.16 0.467 0.238 0.72 0.238s0.506-0.080 0.72-0.238l11.602-8.691c0.304-0.227 0.482-0.582 0.482-0.962v-16.864c0-0.53-0.347-0.995-0.853-1.147zM16 29.027v-13.293h-10.405v-9.87l10.405-3.139v13.010h10.4v5.502l-10.4 7.79z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgencymoduleActive);
export default __webpack_public_path__ + "static/media/icon-agencymodule-active.cefdf373.svg";
export { ForwardRef as ReactComponent };